import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { SvgIcon } from 'src/components/common';
// import { ApplicationState } from 'src/store';
// import { useSelector } from 'react-redux';
import format from 'src/utils/format';
import { parseDate } from 'src/utils/tool';
import { Button } from 'zarm';
import abolishedIcon from './images/abolished.svg';
import expiredIcon from './images/expired.svg';
import inactiveIcon from './images/inactive.svg';
import usedIcon from './images/used.svg';
import './index.scss';

interface CouponProps {
  prefixCls?: string;
  renderData: any;
  couponClick?: any;
  usable?: boolean;
  isShowCouponStatusIcon?: boolean;
}

// const CouponOrder = ({ relatedOrderNo }) => (<div className='coupon-order'>订单号：{relatedOrderNo}</div>);
const statusIcon = {
  // 'init': '',
  used: usedIcon,
  expired: expiredIcon,
  inactive: inactiveIcon,
  abolished: abolishedIcon,
};
const Coupon = (props: CouponProps) => {
  const [isFold, setIsFold] = useState(true);
  const { prefixCls, renderData, couponClick, isShowCouponStatusIcon = false } = props;
  const {
    templateName,
    couponStatus,
    fromDate = '',
    toDate = '',
    templateDesc = '',
    explanation = '',
    templateSubName = '',
    limitEachNum = '',
    orderNo = '',
  } = renderData;

  const disabled = couponStatus !== 'init';

  const click = useCallback(() => {
    typeof couponClick === 'function' && couponClick(renderData);
  }, [couponClick]);

  const renderHighLightText = () => {
    const { couponType, reduce } = renderData;
    if (couponType === 'EXCHANGE') {
      return '免费';
    } if (couponType === 'CONVERSION') {
      return '兑换';
    } if (couponType === 'DISCOUNT') {
      return (
        <span>
          {reduce}
          <span className="sm-discount">折</span>
        </span>
      );
    }
    return (
      <span>
        <span className="sm-amount">￥</span>
        {reduce}
      </span>
    );
  };
  const renderSillText = () => {
    const { sill, couponType } = renderData;
    if (couponType === 'EXCHANGE') {
      return '无门槛使用';
    }
    if (couponType === 'CONVERSION') {
      return '无门槛使用';
    }
    if (sill === -1) {
      return '无门槛使用';
    }
    return `满￥${sill}使用`;
  };

  return (
    <div className={classnames('coupon_component', prefixCls, { disabled })}>
      <div className={classnames('base', { fold: isFold })}>
        {Boolean(orderNo) && couponStatus === 'used' && (
          <div className="coupon_component-order">
            <span>订单号：{orderNo}</span>
          </div>
        )}
        <div className="coupon-body">
          <div className="info">
            <div className="num">
              <p className="discount free">
                {renderHighLightText()}
              </p>
              <p className="min_consume">{renderSillText()}</p>
            </div>
            <div className="info-detail">
              <div className="name">{templateName}</div>
              <p className="attached-msg">{templateSubName}</p>
              <p className="expire-date">
                {format.date(fromDate, 'yyyy.MM.dd hh:mm')} 至 {format.date(toDate, 'yyyy.MM.dd hh:mm')}
              </p>
            </div>
            {
              isShowCouponStatusIcon && statusIcon[couponStatus]
                ? <SvgIcon type="img" src={statusIcon[couponStatus]} />
                : null
            }
          </div>
          <div className="coupon-footer">
            <div className={classnames('fold', { 'pack-up': !isFold })} onClick={() => setIsFold(!isFold)}>
              使用说明
            </div>
            <Button disabled={disabled} theme="primary" size="xs" className="use" onClick={click} shape="round">
              立即使用
            </Button>
          </div>
        </div>
        <div
          className={classnames('detail', {
            fold: isFold,
          })}
        >
          <div className="ellipsis">{explanation}</div>
        </div>
      </div>
    </div>
  );
};

export default Coupon;
